import { apiClient } from 'md-base-tools/apiClient';
import store from '../store'
const acpToken = store.getters.acp_token;
const header = {
    client: 4,
    user_id: acpToken ? acpToken.split(':')[0] : '',
    userid: acpToken ? acpToken.split(':')[0] : '',
    token: acpToken ? acpToken.split(':')[1] : ''
}
const callback = function(err) {
    console.log('err', err)
}

const needLogin = false
const host = 'acp';
const env = process.env.VUE_APP_ENV; // 环境

const acpApis = apiClient({
    host,
    env,
    header,
    needLogin,
    callback
})

export const post = (url, option, header) => {
	return acpApis({
		method: 'post',
        url: url,
        props: option,
        header
	})
}
export const get = (url, option, header) => {
	return acpApis({
		method: 'get',
        url: url,
        props: option,
        header
	})
}

export default acpApis;
